import { buildResourceAlertsFromPayload } from './resourceAlerts';

// A claim receipt can contain several activities and coin lots. Celebrate the
// actual awarded total once per resource, retaining occurrence IDs for hydration.
export const queueClaimedRewardCelebrations = ({ payload, queueResourceCelebration }) => {
  const grouped = new Map();
  buildResourceAlertsFromPayload({ payload, isAnonymous: false }).forEach((alert) => {
    const contributions = alert.rewardContributions
      || (alert.rewardId ? [{ ...alert, id: alert.rewardId }] : null);
    const field = alert.type === 'gettoncini' ? 'amount' : 'delta';
    const existing = grouped.get(alert.type);
    if (!existing) {
      grouped.set(alert.type, { ...alert, ...(contributions ? { rewardContributions: contributions } : {}) });
      return;
    }
    existing[field] += alert[field];
    if (existing.rewardContributions && contributions) {
      existing.rewardContributions = [...existing.rewardContributions, ...contributions];
    }
  });
  let count = 0;
  grouped.forEach((rewardAlert, type) => {
    const id = queueResourceCelebration(type, {
      delta: type === 'gettoncini' ? rewardAlert.amount : rewardAlert.delta,
      rewardAlert,
      delayMs: 500,
    });
    if (id) count += 1;
  });
  return count;
};
